module.exports = __webpack_public_path__ + "static/img/three_icon_5.ec591fdc.png";